import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { CredentialData } from '@/common/types';

interface ProviderCredentialProps {
  credential: CredentialData;
}

const ProviderCredential: React.FC<ProviderCredentialProps> = ({
  credential,
}) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id={`tooltip-${credential.id}`}>{credential.title}</Tooltip>
      }
    >
      <span>{credential.abbreviation}</span>
    </OverlayTrigger>
  );
};

export default ProviderCredential;
